import { useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';
import { EditCustomer } from "./EditCustomer";

export const CustomerTable = () => {
  const { customersList } = useSelector((state) => state.catalogue);
  const [edit, setEdit] = useState(false)
  const [item, setItem] = useState({});

  const edit2 = (item) => {
    setEdit(true);
    setItem(item)
  }

  const columns = [
    {
      name: "Nombre",
      selector: row => [row.name],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.name}</span>
    },
    {
      name: "Apellido Paterno",
      selector: row => [row.lastName],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.lastName}</span>
    },
    {
      name: "Apellido Materno",
      selector: row => [row.mothersLastName],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.mothersLastName}</span>
    },
    {
      name: "Celular",
      selector: row => [row.cellphone],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.cellphone}</span>
    },
    {
      name: "Correo Electronico",
      selector: row => [row.email],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.email}</span>
    },
    {
      name: "Telefono",
      selector: row => [row.telephone],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.telephone}</span>
    },
    {
      name: "¿Quien Recomendo?",
      selector: row => [row.whoRecommend],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.whoRecommend}</span>
    },
    {
      name: "Contacto",
      selector: row => [row.contact],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.contact}</span>
    },
    {
      name: "Estatus",
      selector: row => [row.status],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.status === 1 ? "Activo" : "Inactivo"}</span>
    },
    {
      name: "Editar",
      width: "85px",
      cell: row => <span className="text-center w-100">
        <i className={`fe fe-edit .hover`} role='button' onClick={() => edit2(row)}></i>
      </span>
    },
  ]
  const tableDatas = {
    columns,
    data: customersList,
  };
  return (
    <>
      <DataTableExtensions {...tableDatas} >
        <DataTable
          columns={columns}
          data={customersList}
          noHeader
          defaultSortField="id"
          defaultSortAsc={false}
          striped={true}
          center={true}
          persistTableHead
          pagination
          highlightOnHover />
      </DataTableExtensions>
      <EditCustomer item={item} isOpen={edit} setIsOpen={setEdit} />
    </>
  )
}